import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_56.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter56.json";
import Head from "next/head";
export default function Chapter_56() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  //   const corosalref = useRef()

  //   useEffect(()=>{
  //     if(corosalref.current)
  //     {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent",corosalref.current);
  // },[corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Tantra unites Sattva, Rajas, and Tamas, guiding the ego toward luminous Divine Infinite Being."
        ></meta>
        <meta
          property="og:title"
          content="Jung’s Mandala Psychology and the Tantra of Divine Union"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Drawing on Jung’s mandala psychology and the Mahanirvana Tantra, this teaching explores Sattva, Rajas, and Tamas as the luminous body of light, the dynamic force of becoming, and the material self. Through their union, the waking self merges with the Divine Double, awakening higher consciousness and revealing heaven’s presence in the eternal now."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=56"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=56"
        ></meta>
        <meta
          name="twitter:title"
          content="Gospel of Thomas and the Divine Unity of All Beings"
        ></meta>
        <meta
          name="twitter:description"
          content="From Jung’s insights into Kundalini Yoga to the Mahanirvana Tantra’s vision of Sattva, Rajas, and Tamas, discover the sacred interplay of stillness, action, and form. This union dissolves ego boundaries, ignites the body of light, and unites matter with spirit—awakening the timeless, living truth of our Divine Infinite Being."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=56" />
      </Head>
      <Common_html BlockData={BlockData} />

    </>
  );
}
